import React from 'react';
import PropTypes from 'prop-types';
import * as Constant from 'constant';
import Button from 'components/common/Button';

LoadingButton.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  size: PropTypes.oneOf([
    Constant.SIZE.xs,
    Constant.SIZE.small,
    Constant.SIZE.medium,
    Constant.SIZE.large,
    Constant.SIZE.xl,
  ]),
  rounded: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  iconName: PropTypes.string,
  iconPosition: PropTypes.oneOf(Object.values(Constant.POSITION)),
  isLoading: PropTypes.bool,
  width: PropTypes.string,
  id: PropTypes.string,
  dataTestId: PropTypes.string,
};

LoadingButton.defaultProps = {
  variant: Constant.VARIENT.contained,
  dataTestId: 'loadingButton',
};

function LoadingButton(props) {
  return (
    <Button
      id={props.id}
      text={props.text}
      color={props.color}
      variant={props.variant}
      size={props.size}
      rounded={props.rounded}
      disabled={props.disabled}
      onClick={!props.isLoading ? props.onClick : undefined}
      iconName={'spinner'}
      isLoading={props.isLoading}
      iconPosition={props.iconPosition}
      iconAnimationType={Constant.ICON_ANIMATION_TYPE.spin}
      width={props.width}
      dataTestId={props.dataTestId}
    />
  );
}

export default LoadingButton;
